import { useGetIdentity } from "react-admin";
import { useLocation, useNavigate } from 'react-router-dom'
import GoogleTranslate from "../common/GoogleTranslate";
import LogoutIcon from "../../assets/images/logout.svg";
type ApplicationHeaderProps = {
  role?: string | null;
  subscriberId?: string | number;
  subscriberData?: any;
  applicantName?: string;
  onLogout?: () => void;
};

const ApplicatonHeader = ({
  role,
  subscriberId,
  subscriberData,
  applicantName = "",
  onLogout,
}: ApplicationHeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = useGetIdentity();
  const isDocuploadRoute = location.pathname.startsWith('/admin');
  return (
    <div>
      <h6 className="px-2"> {subscriberId && <img src={`https://uatapiml.dvapply.com/users/logo/${subscriberId}`} alt="" style={{ width: 35, height: 30 }} />} {subscriberData?.CompanyName}</h6>
      <div className='d-flex flex-sm-column flex-md-row align-item-center justify-content-between vr-app-header__row'>
       
        <div className="p-2 order-sm-1 order-md-1 vr-app-header__title">
          <h6>Proof Documents for <strong>{applicantName}</strong></h6>
        </div> 
        {!isDocuploadRoute && <div className="p-2 order-sm-3 order-md-3"> <GoogleTranslate/></div>}
        {data?.redirectUrl && (
          <button
            className="p-2 order-sm-2 order-md-2 btn btn-sm btn-secondary print-hide vr-logout-btn vr-app-header__logout"
            onClick={() => {
              if (onLogout) {
                onLogout();
                return;
              }
              localStorage.removeItem('auth');
              navigate('/ats');
            }}
          >
            <img src={LogoutIcon} alt="" className="vr-logout-btn__icon" />
            Logout
          </button>
        )}      
      </div>
    </div>
  );
};

export default ApplicatonHeader;
